import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../../shared/api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../../shared/api/firebase/references";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";

export interface NarAgentGridOrgTab {
  id: string;
  label: string;
}

interface ClientWiseConfigEntry {
  client?: string;
  client_id?: string;
}

interface ClientWiseConfigDocument {
  client_wise_config?: ClientWiseConfigEntry[];
}

const formatClientTabLabel = (clientName: string): string =>
  capitalizeWordsSeperatedByUnderScore(clientName.trim()).toUpperCase();

/** Load automation client IDs and labels from the Auth Grid client configuration. */
const useNarAgentGridOrgTabs = () => {
  const [tabs, setTabs] = useState<NarAgentGridOrgTab[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOrgTabs = async () => {
      setLoading(true);
      setError(null);
      try {
        const document =
          await FirestoreService.getDocument<ClientWiseConfigDocument>(
            FirestoreDocumentReference.narClientWiseConfig(),
          );
        setTabs(
          (document?.client_wise_config ?? [])
            .filter(
              (entry): entry is ClientWiseConfigEntry & { client_id: string } =>
                typeof entry.client_id === "string" &&
                entry.client_id.length > 0,
            )
            .map((entry) => ({
              id: entry.client_id,
              label: formatClientTabLabel(
                entry.client?.trim() || entry.client_id,
              ),
            })),
        );
      } catch (fetchError) {
        console.error("Error fetching NAR Agent Grid org tabs:", fetchError);
        setError("Failed to load organization tabs.");
        setTabs([]);
      } finally {
        setLoading(false);
      }
    };
    void fetchOrgTabs();
  }, []);

  return { tabs, loading, error };
};

export default useNarAgentGridOrgTabs;
